export default __webpack_public_path__ + "static/media/ic_company_logo_.850b72b8.png";